/**
 * Block 13 PR-G Phase 6.5 #14 — Inline badge для секций с пустыми
 * required-полями.
 *
 * UX rationale: на mobile кнопки PDF/Share гейтятся `selectIsDraftReadyForPdf`
 * (требуется customerName + executorName + totalCost > 0). Tap-when-disabled
 * на mobile неочевиден — пользователь не понимает что заблокировано и почему.
 * Section-level badge даёт явный визуальный сигнал «в этом блоке поля не
 * заполнены», а inline message выше BottomActions перечисляет конкретные
 * секции.
 *
 * Design system compliance:
 *   - P-038: nested badge inside SectionCard naturally inherits bg-card via
 *     no own bg setting — но мы рендерим как pill с явным bg-accent для
 *     visual contrast → MUST задать ink на accent (P-039 text-ink).
 *   - P-039: text-ink (pure black) — readable на accent yellow background.
 *   - P-041: text-accent / bg-cta запрещены на body / headings. Badge
 *     использует bg-accent (orange highlight) — это semantic accent
 *     surface, не нарушает правило (bg-accent для callout pills allowed
 *     в design-system.md v0.6).
 *
 * Reference:
 *   - PRD §10.13.2 «UX disabled buttons should explain why»
 *   - Aibek decision 2026-05-26: keep PDF/Share gates + add section badges +
 *     inline message above BottomActions
 */

export interface MissingFieldsBadgeProps {
  /** Test-id для query в тестах. */
  testId?: string;
}

export function MissingFieldsBadge({ testId }: MissingFieldsBadgeProps) {
  return (
    <span
      data-testid={testId}
      aria-label="В этом блоке есть незаполненные обязательные поля"
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-accent text-ink text-xs font-semibold leading-none"
    >
      <span aria-hidden="true">!</span>
      Заполните
    </span>
  );
}
